<template>
    <div class="mb-4">
        <div class="container py-3">
            <div class="breadcrumbs-retos mb-3" :class="{'mt-5' : product.PRODUCT_TYPE_ID === 10 && isMobile}">
                <a href="/home-bat">
                    <img src="/img/icons/homeBread.svg" alt="" />
                </a>
                <a class="link cursor-pointer" href="#" @click="returnBack()">Catálogo</a>
                <a class="link cursor-pointer" href="#" >Categoria del producto /</a>
                <span class="color-active-miga"><strong>Detalle</strong></span>
            </div>
            <a class="my-3" href="#" @click="returnBack()"><img src="/img/icons/regresar.svg" alt="icon"></a>
        </div>
        <div class="container mt-0 mt-md-5 text-bat">
            <div class="row">
                <div class="col-12 col-md-12 col-lg-7">
                    <div class="p-4 position-relative justify-content-center mx-auto text-center d-none d-md-block">
                        <img class="img-fluid p-5 rounded" :src="product.PRODUCT_IMAGE !== null ? url_media + product.PRODUCT_IMAGE.replace('~/', '') : '/img/default_image.png'" :alt="product.NAME">
                        <div class="position-absolute top-0 start-0">
                            <span class="px-1 py-2 bg-info bg-opacity-10 fs-7 fw-semibold rounded">
                                {{ product.CATEGORY }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-5 container">
                    <h3 class="text-title-bat mb-2">
                        {{ product.NAME }}
                    </h3>
                    <p class="mb-0">
                        Canjéalo por
                    </p>
                    <p class="text-title-bat text-indigo fs-5">
                        {{ product.VALUE_POINTS }} puntos
                    </p>
                    <div class="position-relative justify-content-center mx-auto text-center col-8 my-4 d-block d-md-none">
                        <img class="img-fluid rounded" :src="product.PRODUCT_IMAGE !== null ? url_media + product.PRODUCT_IMAGE.replace('~/', '') : '/img/default_image.png'" :alt="product.NAME">
                        <div class="position-absolute top-0 start-0">
                            <span class="px-1 py-2 bg-info bg-opacity-10 fs-7 fw-semibold rounded">
                                {{ product.CATEGORY }}
                            </span>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-between align-items-center">
                        <div class="col-4">
                            <p>
                                <strong>
                                    {{ product.INVENTORY }} unds
                                </strong>
                                disponibles
                            </p>
                        </div>
                        <div class="col-4">
                            <div v-if="product.PRODUCT_TYPE_ID == 12 || product.PRODUCT_TYPE_ID == 13" class="row">
                                <div class="col-4 d-flex justify-content-center">
                                    <p class="bg-secondary bg-opacity-10 text-center px-3 py-1 rounded">
                                        <strong>
                                            {{ amount }}
                                        </strong>
                                    </p>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-4 d-flex justify-content-center h-100">
                                    <button :class="amount <= 1 ? 'disabled': ''" :disabled="amount <= 1" class="border-0 bg-transparent" @click="amount > 1 ? amount-- : ''">
                                        <img src="/img/icons/cantidad-flecha-abajo.svg" alt="">
                                    </button>
                                </div>
                                <div class="col-4 d-flex justify-content-center">
                                    <p class="bg-secondary bg-opacity-10 text-center px-3 py-1 rounded">
                                        <strong>
                                            {{ amount }}
                                        </strong>
                                    </p>
                                </div>
                                <div class="col-4 col-4 d-flex justify-content-center h-100">
                                    <!-- <button :class="amount >= product.INVENTORY - 1 ? 'disabled': ''"  :disabled="amount >= product.INVENTORY - 1" class="border-0 bg-transparent" @click="amount < product.INVENTORY-1 ? amount++ : ''"> -->
                                    <button :class="amount >= product.INVENTORY ? 'disabled': ''"  :disabled="amount >= product.INVENTORY " class="border-0 bg-transparent" @click="amount < product.INVENTORY ? amount++ : ''">
                                        <img src="/img/icons/cantidad-flecha-arriba.svg" alt="">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Botones para canjear -->
                    <div class="row my-3 mt-md-5 mb-md-4">
                        <div v-if="product.PRODUCT_TYPE_ID == 12 || product.PRODUCT_TYPE_ID == 13" class="col-12 p-b-4">
                            <p style="font-size: 12px">Solo puedes redimir un producto de este tipo</p>
                        </div>
                        <div v-if="product.PRODUCT_TYPE_ID == 10" class="d-none d-md-block">
                            <p class="text-black  bg-danger bg-opacity-25 d-flex align-items-center fs-6">
                                <img class="border-start py-3 px-3 border-5 border-danger me-1" src="/img-version2/icons/danger.svg" alt="">
                                Al realizar tu pedido, solo podrás utilizar un código de descuento por compra.
                            </p>
                        </div>
                        <div class="col-12 col-md-6 mb-2 mb-md-0 d-flex justify-content-center">
                            <button :id="product.GUID + '-btn-canjea-ahora-detail'" :title="product.NAME" class="border-0 rounded bg-darkblue px-4 px-md-5 py-2 text-white mx-auto fw-bold w-100 w-md-auto" @click="addProductToCart(true)">
                                Canjear ahora
                            </button>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-center">
                            <button :id="product.GUID + '-btn-agregar-carrito-detail'" :title="product.NAME" v-if="loading === 0" type="submit" class="border-0 bg-transparent px-5 py-2 text-indigo mx-auto text-decoration-underline"  @click="addProductToCart(false)">
                                Agregar al carrito
                            </button>
                            <button v-else :id="product.GUID + '-btn-agregar-carrito-detail'" :title="product.NAME" type="submit" class="border-0 bg-transparent px-4 px-md-5 py-2 text-indigo mx-auto text-decoration-underline w-100 w-md-auto">
                                Agregar al carrito <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>

                    <p v-if="product.PRODUCT_TYPE_ID === 2">
                        Tus productos físicos estarán llegando en <strong>15 días hábiles</strong> a partir de la fecha de redención.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 1">
                        Tus productos digitales estarán llegando en <strong>1 día hábil</strong> a partir de la fecha de redención.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 3">
                        Tus recargas digitales estarán llegando en <strong>2 días hábiles</strong> a partir de la fecha de redención.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 7">
                        Tus productos estarán llegando en <strong>1 día hábil</strong> a partir de la fecha de redención.</p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 5">
                        A los <strong>3 días hábiles</strong> después de la redención, debes dirigirte a una tienda Falabella a nivel nacional.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 6">
                        En los siguientes <strong>4 días hábiles</strong> recibirás un correo electrónico con el bono en PDF.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 8">
                        A los <strong>3 días hábiles</strong> después de la redención, debes dirigirte a los establecimientos a nivel nacional indicando el número del convenio 1618.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 9">
                        A los <strong>3 días hábiles</strong> después de la redención, debes dirigirte a un almacen Makro a nivel nacional.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 10">
                        Tus productos digitales estarán llegando en <strong>3 día hábil</strong> a partir de la fecha de redención.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 11">
                        En los siguientes <strong>4 días</strong> recibirás un correo electrónico con la confirmación de tu recarga.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 12">
                        En los siguientes <strong>15 días hábiles</strong> recibirás tu tarjeta Sodexo.
                    </p>
                    <p v-else-if="product.PRODUCT_TYPE_ID === 11">
                        En los siguientes <strong>15 días hábiles</strong> recibirás tu tarjeta Sodexo.
                    </p>
                    <div class="accordion accordionDescriptionProductDetail" id="accordionProductDetail">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                    Descripción
                            </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <p v-html="product.LONG_DESCRIPTION"></p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    Términos y condiciones
                            </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <p v-html="product.TERMS"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="product.PRODUCT_TYPE_ID == 10" class="d-block d-md-none">
                    <div class="text-black shadow-lg fixed-top rounded-4 align-items-center floatDangerWebOrdering" style="">
                        <div class="row d-flex align-items-center justify-content-center">
                            <div class="col-2 d-flex align-items-center justify-content-center">
                                <img class="py-3 border-5 border-danger" src="/img-version2/icons/danger.svg" style="padding-left: 25px !important;" alt="">
                            </div>
                            <div class="col-10">
                                <p class="fw-bold mb-0 text-break fs-7"> Al realizar tu pedido, solo podrás utilizar un código de descuento por compra.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            default: null,
        },
        url_media: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            amount: 1,
            isMobile:window.innerWidth < 768,
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        },
        returnBack() {
            if(window.history.length > 3){
                window.history.back();
            }else{
                window.location.href = '/catalogo';
            }
        },
        addProductToCart(goToCart) {
            this.loading++
            var dataSend = {
                "product_guid": this.product.GUID,
                "product_reference_guid": this.product.REFERENCE_ID,
                "quantity": this.amount,
                "go_to_cart": goToCart,
            }
            axios.post('/create-shopping-cart', dataSend).then(
                ({data}) => {
                    console.log(data)
                    if(goToCart === true){
                        window.location.href = '/show-shopping-cart'
                    }else{
                        this.$notify({
                                         title: 'Agregado al carrito',
                                         message: 'Producto agregado al carrito satisfactoriamente',
                                         type: 'success'
                                     });
                        this.loading--
                        setTimeout(() => {
                            window.location.reload()
                        }, 1000)
                    }
                })
        },
    },
}
</script>
